import React from 'react';
import { Link } from 'react-router-dom';
import image from "../../../assets/img/shape/content.png";
import brand0 from "../../../assets/img/brand/brand-0.png";
import brand1 from "../../../assets/img/brand/brand-1.png";
import brand2 from "../../../assets/img/brand/brand-2.png";
import brand3 from "../../../assets/img/brand/brand-3.png";
import brand4 from "../../../assets/img/brand/brand-4.png";
import brand5 from "../../../assets/img/brand/brand-5.png";
import brand6 from "../../../assets/img/brand/brand-6.png";
import brand7 from "../../../assets/img/brand/brand-7.png";
import brand8 from "../../../assets/img/brand/brand-8.png";
import brand9 from "../../../assets/img/brand/brand-9.png";
import brand10 from "../../../assets/img/brand/brand-10.png";
import brand11 from "../../../assets/img/brand/brand-11.png";
import brand12 from "../../../assets/img/brand/brand-12.png";
import brand13 from "../../../assets/img/brand/brand-13.png";

const BannerFour = () => {
    return (
        <div className="banner__four">
            <div className="bg-video">
                <video autoPlay muted loop playsInline>
                    <source src="https://buildgo-react.vercel.app/static/media/banner.b1e80eca5dee07cccccd.mp4" type="video/mp4" />
                </video>
            </div>
            <div className="container">
                <div className="row">
                    <div className="col-xl-12">
                        <div className="banner__four-content">
                            <span className="subtitle wow fadeInLeft" data-wow-delay=".3s">1987 yılından bugüne</span>
                            <h1 className="wow fadeInRight" data-wow-delay=".6s" style={{ fontSize: '80px'}}>Ayyıldız İnşaat</h1>
                                <h2 className="wow fadeInRightTwo" data-wow-delay=".9s" style={{ fontSize: '50px'}}>Sanayi ve Ticaret Limited Şirketi</h2>
                                <div className="wow fadeInDown" data-wow-delay="1.2s">
                                    <Link className="build_button" to="/projeler"><b className='build-button-project'>PROJELER</b><i className="flaticon-right-up"></i></Link>
                                </div>
                            {/* <Link to="/request-quote"><img className="h_rotate" src={image} alt="image" /></Link> */}
                        </div>
                    </div>
                </div>
            </div>
            <div className="container">
                <div className="row">
                    <div className="col-xl-12">
                        <div className="banner__four-brand">
                            <div className="title">
                                <h4 className='references'>Referanslar</h4>
                            </div>
                            <div className="scroll__slider">
                                <div className="text-slide">
                                    <div className="sliders text_scroll">
                                        <ul>
                                            <li><img src={brand0} alt="image" /></li>
                                            <li><img src={brand1} alt="image" /></li>
                                            <li><img src={brand2} alt="image" /></li>
                                            <li><img src={brand3} alt="image" /></li>
                                            <li><img src={brand4} alt="image" /></li>
                                            <li><img src={brand5} alt="image" /></li>
                                            <li><img src={brand6} alt="image" /></li>
                                            <li><img src={brand7} alt="image" /></li>
                                            <li><img src={brand8} alt="image" /></li>
                                            <li><img src={brand9} alt="image" /></li>
                                            <li><img src={brand10} alt="image" /></li>
                                            <li><img src={brand11} alt="image" /></li>
                                            <li><img src={brand12} alt="image" /></li>
                                            <li><img src={brand13} alt="image" /></li>
                                        </ul>
                                    </div>
                                    <div className="sliders text_scroll">
                                        <ul>
                                        <li><img src={brand1} alt="image" /></li>
                                            <li><img src={brand0} alt="image" /></li>
                                            <li><img src={brand2} alt="image" /></li>
                                            <li><img src={brand3} alt="image" /></li>
                                            <li><img src={brand4} alt="image" /></li>
                                            <li><img src={brand5} alt="image" /></li>
                                            <li><img src={brand6} alt="image" /></li>
                                            <li><img src={brand7} alt="image" /></li>
                                            <li><img src={brand8} alt="image" /></li>
                                            <li><img src={brand9} alt="image" /></li>
                                            <li><img src={brand10} alt="image" /></li>
                                            <li><img src={brand11} alt="image" /></li>
                                            <li><img src={brand12} alt="image" /></li>
                                            <li><img src={brand13} alt="image" /></li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default BannerFour;